import { Component, Inject, LOCALE_ID } from '@angular/core'
import { MatCardModule } from '@angular/material/card'
import { MatTabsModule } from '@angular/material/tabs'
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog'
import { CommonModule } from '@angular/common'
import { Programa } from '../../models/programa.model'
import { DocenteComponent } from './docente/docente.component'
import { DisciplinaComponent } from './disciplina/disciplina.component'
import { LinhaPesquisaComponent } from "./linha-pesquisa/linha-pesquisa.component";
import { MatButtonModule } from '@angular/material/button'
import { MatTooltipModule } from '@angular/material/tooltip'
import { HttpClient } from '@angular/common/http'

@Component({
  selector: 'app-programa-visualizar',
  templateUrl: 'programa-visualizar.component.html',
  styleUrls: ['./programa-visualizar.component.scss'],
  imports: [
    CommonModule,
    MatDialogModule,
    MatCardModule,
    MatTabsModule,
    MatButtonModule,
    MatTooltipModule,
    LinhaPesquisaComponent,
    DisciplinaComponent,
    DocenteComponent,
  ]
})
export class ProgramaVisualizarComponent {

  txtE: string = ' e '
  conceitoCapes?: string

  constructor(
    public dialogRef: MatDialogRef<ProgramaVisualizarComponent>,
    @Inject(MAT_DIALOG_DATA) public programa: Programa,
    @Inject(LOCALE_ID) public locale: string,
    private http: HttpClient,
  ) {
    if (this.locale != 'pt') {
      this.txtE = ' and '
    }
    this.carregaConceitoCapes()
  }

  private carregaConceitoCapes(): void {
    this.http.get('assets/codigos-capes-conceitos.csv', { responseType: 'text' }).subscribe({
      next: csv => {
        const linha = csv.replace(/^\uFEFF/, '').split(/\r?\n/)
          .find(linha => linha.split(',')[0]?.trim() === this.programa.codigoCapes?.trim())
        this.conceitoCapes = linha?.split(',')[1]?.trim()
      }
    })
  }

  abrirUrl(url: string): void {
    if (url) {
      const destino = url.startsWith('http') ? url : `http://${url}`
      window.open(destino)
    }
  }

}
